import { createNamespacer, createReducer } from "../../commons/js/utils/reducer";

const initialState = {
    isLoading: false,
    weldStatPackages: {
        packageQueuePackages: [],
        shopPackages: [],
    },
    backupWeldStatPackages: {
        packageQueuePackages: [],
        shopPackages: [],
    },
    packageQueueTotalPages: 1,
    backupPackageQueueTotalPages: 1,
    packageQueueCurrentPage: 1,
    backupPackageQueueCurrentPage: 1,
    facilitiesList: [],
    selectedFacility: "",
    openEditpackage: false,
    openEditFacility: false,
    updatedGroupedStat: {},
    isScheduler: false,
    hourlyWeldInches: {},
    newHourlyWeldInches: {},
    toggleWeldInches: false,
    searchKey: '',
    packageQueueLoader: false,
    shopPackagesLoader: false,
    isSaveEnabled: false,
    fabDateDetails: {
        isPastFabDate: false,
        isFabDateChanged: false,
    },
    materialList: [],
    material: "",
    selectedExport: { value: "", label: "Export" },
    shopFacility: "",
    shopMaterial: "",
}

const shopManager = createNamespacer("SCHEDULE_MANAGER");

const shopManagerReducer = createReducer(initialState, {
    [shopManager("SET_LOADING")]:(state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    [shopManager("SET_PACKAGE_QUEUE_LOADING")]:(state, action) => {
        return {
            ...state,
            packageQueueLoader: action.payload.value
        }
    },
    "SET_SHOP_PACKAGES_LOADING":(state, action) => {
        return {
            ...state,
            shopPackagesLoader: action.payload.value
        }
    },
    [shopManager("SET_PACKAGE_QUEUE_PACKAGES")]:(state, action) => {
        return {
            ...state,
            weldStatPackages: {
                ...state.weldStatPackages,
                packageQueuePackages: action.payload.value,
            }
        }
    },
    "SET_UPDATED_PACKAGE_QUEUE_PACKAGES":(state, action) => {
        return {
            ...state,
            weldStatPackages: {
                ...state.weldStatPackages,
                packageQueuePackages: action.payload.value,
            }
        }
    },
    [shopManager("SET_PACKAGE_QUEUE_TOTAL_PAGES")]:(state, action) => {
        return {
            ...state,
            packageQueueTotalPages: action.payload.value,
            packageQueueCurrentPage: action.payload.currentPage
        }
    },
    "SET_UPDATED_PACKAGE_QUEUE_TOTAL_PAGES":(state, action) => {
        return {
            ...state,
            packageQueueTotalPages: action.payload.value,
            packageQueueCurrentPage: action.payload.currentPage
        }
    },
    [shopManager("SET_PACKAGE_QUEUE_CURRENT_PAGE")]:(state, action) => {
        return {
            ...state,
            packageQueueCurrentPage: action.payload.value,
        }
    },
    [shopManager("SET_SHOP_PACKAGES")]:(state, action) => {
        return {
            ...state,
            weldStatPackages: {
                ...state.weldStatPackages,
                shopPackages: action.payload.value,
            }
        }
    },
    "SET_UPDATED_SHOP_MANAGER_PACKAGES":(state, action) => {
        return {
            ...state,
            weldStatPackages: {
                ...state.weldStatPackages,
                shopPackages: action.payload.value,
            }
        }
    },
    "SET_UPDATED_BACKUP_SHOP_MANAGER_PACKAGES":(state, action) => {
        return {
            ...state,
            backupWeldStatPackages: {
                ...state.backupWeldStatPackages,
                shopPackages: action.payload.value,
            }
        }
    },
    "SET_UPDATED_BACKUP_PACKAGE_QUEUE_PACKAGES":(state, action) => {
        return {
            ...state,
            backupWeldStatPackages: {
                ...state.backupWeldStatPackages,
                packageQueuePackages: action.payload.value,
            }
        }
    },
    "SET_SHOP_MANAGER_UPDATED_LEFT_AND_RIGHT_SECTION_PACKAGES": (state, action) => {
        return {
            ...state,
            weldStatPackages: {
                packageQueuePackages:  action.payload.items,
                shopPackages: action.payload.selected,
            }
        }
    },
    "SET_BACKUP_LEFT_AND_RIGHT_PACKAGES":(state, action) => {
        return {
            ...state,
            backupWeldStatPackages: {
                packageQueuePackages: action.payload.packageQueuePackages,
                shopPackages: action.payload.shopPackages
            }
        }
    },
    "SET_BACKUP_LEFT_TOTOAL_AND_CURRENT_PAGE_DETAILS":(state, action) => {
        return {
            ...state,
            backupPackageQueueTotalPages: action.payload.packageQueueTotalPages,
            backupPackageQueueCurrentPage: action.payload.packageQueueCurrentPage,
        }
    },
    [shopManager("SET_ACTIVE_FACILITITES")]:(state, action) => {
        return {
            ...state,
            facilitiesList: action.payload.facilitiesList,
        }
    },
    [shopManager("SET_SELECTED_FACILITY")]:(state, action) => {
        return {
            ...state,
            selectedFacility: action.payload.value,
        }
    },
    [shopManager("SET_IS_SAVE_ENABLED")]:(state, action) => {
        return {
            ...state,
            isSaveEnabled: action.payload.value,
        }
    },
    [shopManager("TOGGLE_EDIT_PACKAGE")]:(state, action) => {
        return {
            ...state,
            openEditpackage: action.payload.value,
        }
    },
    [shopManager("TOGGLE_EDIT_FACILITY")]:(state, action) => {
        return {
            ...state,
            openEditFacility: action.payload.value,
        }
    },
    [shopManager("SET_SHOP_FACILITY")]:(state, action) => {
        return {
            ...state,
            shopFacility: action.payload.value,
        }
    },
    [shopManager("SET_SHOP_MATERIAL")]:(state, action) => {
        return {
            ...state,
            shopMaterial: action.payload.value,
        }
    },
    [shopManager("CLEAR_GROUPED_STAT")]:(state, action) => {
        return {
            ...state,
            updatedGroupedStat: initialState.updatedGroupedStat,
        }
    },
    [shopManager("SET_NEW_GROUPED_STAT")]:(state, action) => {
        let newGroupedStat = {}

        newGroupedStat[action.payload.id] = {
            ...state.updatedGroupedStat[action.payload.id],
            [action.payload.key] : action.payload.value,
        }

        return {
            ...state,
            updatedGroupedStat: { ...newGroupedStat },
        }

    },
    [shopManager("SET_IS_SCHEDULER")]:(state, action) => {
        return {
            ...state,
            isScheduler: action.payload.value,
        }
    },
    [shopManager("SET_HOURLY_WELD_INCHES")]:(state, action) => {
        return {
            ...state,
            hourlyWeldInches: action.payload.value,
        }
    },
    [shopManager("SET_SEARCH_STRING")]:(state, action) => {
        return {
            ...state,
            searchKey: action.payload.value,
        }
    },
    [shopManager("SET_NEW_HOURLY_WELD_INCHES")]:(state, action) => {
        return {
            ...state,
            newHourlyWeldInches: action.payload.value,
        }
    },
    [shopManager("CLEAR_TOGGLE_INCHES")]:(state, action) => {
        return {
            ...state,
            newHourlyWeldInches: initialState.newHourlyWeldInches,
        }
    },
    [shopManager("TOGGLE_INCHES_EDIT")]:(state, action) => {
        return {
            ...state,
            toggleWeldInches: action.payload.value,
        }
    },
    [shopManager("SET_UPDATED_GROUPED_STAT_ERRORS")]:(state, action) => {
        let newGroupedStat = {}

        newGroupedStat[action.payload.id] = {
            ...state.updatedGroupedStat[action.payload.id], 
            'errors': {
                'factor': action.payload.factorError,
                'no_of_mens': action.payload.NoOfMensError,
                'required_date': action.payload.requiredDateError,
                'shop_position': action.payload.shopPositionError,
            } 
        }

        return {
            ...state,
            updatedGroupedStat: { ...newGroupedStat },
        }

    },
    "SET_FAB_DATE_DETAILS": (state, action) => {
        return {
            ...state,
            fabDateDetails: {...action.payload}
        }
    },
    "SET_SELECTED_FAB_DATE": (state, action) => {
        return {
            ...state,
            fabDateDetails: {
                ...state.fabDateDetails,
                fabDate: action.payload.fabDate,
                isFabDateChanged: action.payload.isFabDateChanged
            }
        }
    },
    [shopManager("SET_MATERIALS_LIST")]:(state, action) => {
        return {
            ...state,
            materialList: action.payload.value,
        }
    },
    [shopManager("SET_SELECTED_MATERIAL")]:(state, action) => {
        return {
            ...state,
            material: action.payload.value,
        }
    },
    [shopManager("SET_SELECTED_EXPORT")]:(state, action) => {
        return {
            ...state,
            selectedExport: action.payload.value,
        }
    },
});

export default shopManagerReducer;
